import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const prefix = "app/network";

type State = {
  isOnline: boolean;
};

const initialState: State = {
  isOnline: navigator.onLine,
};

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
  },
});

export default slice.reducer;
export const { setOnlineStatus } = slice.actions;
